export const initialEventState = {
  name: '',
  description: '',
  startDate: '',
  endDate: '',
  startTime: '',
  endTime: '',
  timeTBA: false,
  endTimeTBA: false,
  dateTBA: false,
  noSpecificTime: false,
  timezone: '',
  spanMultipleDays: false,
  venueName: '',
  country: '',
  lineup: '',
  favoritePerformance: '',
  rating: '',
  notes: '',
  top10: false,
  attended: false,
  wasStreamed: false,
  attendanceType: 'none',
  attendedDates: [],
  attendanceDetails: '',
  additionalDates: [{ date: '', description: '' }],
  artistsSeen: [{ name: '', performance: '', performanceDate: '', setTime: '', seen: false, favorite: false, comment: '', confirmed: false }],
  memorableMoment: false,
  momentCaption: '',
  notableDetails: '',
  eventType: 'festival',
  privacy: 'public'
}

export const createEmptyAttendedDate = () => ({ date: '', description: '' })
export const createEmptyArtist = () => ({
  name: '',
  performance: '',
  performanceDate: '',
  setTime: '',
  seen: false,
  favorite: false,
  comment: '',
  confirmed: false
})